import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ContextUser,  } from "../../context/ContextUser/context";
import { ArrowRight, Bike, Lock, Mail } from "lucide-react";
import {
  Card,
  Container,
  Icon,
  Input,
  InputBox,
  LogoBox,
  Submit,
  SubTitle,
  Title,
  Toggle,
  ToggleButton,
} from "./styled";
import { loginUser } from "../../context/ContextUser/actions";


export default function LoginPage() {
  const navigate = useNavigate();
  const { dispatch, state } = useContext(ContextUser);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleLogin() {
    if (!email || !password) {
      setError("Preencha email e senha");
      return;
    }

    try {
      setError("");

      await loginUser(dispatch, email, password);

      navigate("/dashboard", { replace: true }); // 🔥 redireciona

    } catch (err: any) {
      console.error(err);

      if (err.code === "auth/user-not-found")
        setError("Usuário não encontrado");
      else if (err.code === "auth/wrong-password")
        setError("Senha incorreta");
      else if (err.code === "auth/invalid-email")
        setError("Email inválido");
      else if (err.code === "auth/too-many-requests")
        setError("Muitas tentativas. Tente mais tarde.");
      else setError("Erro ao fazer login");
    }
  }

  return (
    <Container>
      <Card>
        <LogoBox>
          <Bike color="white" size={38} />
        </LogoBox>

        <Title>Bem-vindo</Title>
        <SubTitle>Faça login para continuar</SubTitle>

        <Toggle>
          <ToggleButton active>Login</ToggleButton>
        </Toggle>

        {/* EMAIL */}
        <InputBox>
          <Icon>
            <Mail size={18} />
          </Icon>
          <Input
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputBox>

        {/* SENHA */}
        <InputBox>
          <Icon>
            <Lock size={18} />
          </Icon>
          <Input
            type="password"
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </InputBox>

        {/* ERRO */}
        {error && (
          <span style={{ color: "#ef4444", fontSize: 14 }}>
            {error}
          </span>
        )}

        {/* BOTÃO */}
        <Submit onClick={handleLogin} disabled={state.loading}>
          <ArrowRight size={18} />
          {state.loading ? "Entrando..." : "Entrar"}
        </Submit>
      </Card>
    </Container>
  );
}